import { render, staticRenderFns } from "./UserProxies.vue?vue&type=template&id=51360d8a&"
import script from "./UserProxies.vue?vue&type=script&lang=js&"
export * from "./UserProxies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports